import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import Et3ATag from "../../../../../core/et3-a-tag";
import { TalkhattabatConversationType } from "../../../../../Types";

const ConversationType = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
  matchName: string;
  peerID: number;
}>((props) => {
  const { matchName, conversationType, theme, peerID } = props;
  const { colors } = theme;

  const headerText =
    conversationType === "101C"
      ? "ONE_O_ONE_C"
      : conversationType === "101C_COMMENTS"
        ? "COMMENTS"
        : "ONE_O_TWO_WITH";

  return (
    <ET3Div
      width={0}
      height={45}
      alignItems={"center"}
      fDirection={"row"}
      style={{ width: "auto" }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get(headerText)}
        style={{}}
        color={
          conversationType === "101C_COMMENTS"
            ? colors.all.red
            : colors.all.black
        }
      />
      <Et3Margin top={0} bottom={0} left={5} right={5} />
      {conversationType === "102" ? (
        <Et3ATag
          href={`/users/advanced?id=${peerID}`}
          target="_blank"
          style={{}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={24}
            isSpan={false}
            text={matchName}
            style={{}}
            color={colors.all.black}
          />
        </Et3ATag>
      ) : null}
    </ET3Div>
  );
});

export default ConversationType;
